/**
 * <s-quick-view> — product card quick view pop-up body.
 *
 * Choosing a variant radio sets the form's hidden variant id, updates the price,
 * names the chosen option, enables add to cart, and scrolls the photos to the
 * variant's image. Radios carry data-name, data-price, data-compare, data-media.
 */
class SQuickView extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      this.#choose(radio);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #choose(radio) {
    const idInput = this.querySelector('[data-qv-id]');
    if (idInput) idInput.value = radio.value;

    const chosen = this.querySelector('[data-qv-chosen]');
    if (chosen) chosen.textContent = radio.dataset.name || '';

    const price = this.querySelector('[data-qv-price]');
    const compare = this.querySelector('[data-qv-compare]');
    if (price) {
      price.textContent = radio.dataset.price || '';
      price.classList.toggle('text-sale', Boolean(radio.dataset.compare));
    }
    if (compare) {
      compare.textContent = radio.dataset.compare || '';
      compare.hidden = !radio.dataset.compare;
    }

    const add = this.querySelector('[data-qv-add]');
    if (add) {
      add.disabled = false;
      const label = add.querySelector('[data-qv-add-label]');
      if (label) label.textContent = add.dataset.addLabel || label.textContent;
    }

    const scroller = this.querySelector('[data-qv-scroller]');
    const slide = radio.dataset.media && scroller?.querySelector(`[data-qv-slide="${radio.dataset.media}"]`);
    if (scroller && slide) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
  }
}

if (!customElements.get('s-quick-view')) customElements.define('s-quick-view', SQuickView);
